// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".e454d6032016e48c124a99f4972a6c394b5e1e47.chunk.js";
};